<template>
    <div>
        <b-row>
            <b-col md="2"></b-col>
            <b-col md="3">
                <eb-select
                    type="select"
                    v-model="selected"
                    :options="options"
                    label="text"
                    id="value"
                    placeholder="Search Type"
                ></eb-select>
            </b-col>
            <b-col md="4" v-if="this.selected.value == 'status'">
                <eb-select
                    type="select"
                    v-model="selectedStatus"
                    :options="statusOptions"
                    label="text"
                    id="value"
                    @input="onChangeStatus"
                    placeholder="Select Status"
                ></eb-select>
            </b-col>
            <b-col md="4" v-if="this.selected.value != 'status'">
                <Vue-Simple-Suggest
                    :nullable-select="true"
                    v-model="searchInput"
                    :debounce="1000"
                    display-attribute="name"
                    value-attribute="_id"
                    placeholder="Enter Data"
                ></Vue-Simple-Suggest>
                <button class="text-grey searchIcon" @click="searchResult()">
                    <i class="fa fa-search mt-2" aria-hidden="true"></i>
                </button>
            </b-col>
            <b-col md="3">
                <eb-select
                    style="background-color: #fff"
                    id="text"
                    type="text"
                    label="text"
                    :options="dateOption"
                    v-model="selectedDate"
                    :selected="selectedDate.text"
                    @input="changeDate"
                >
                </eb-select>
                <b-modal
                    title="Select Date"
                    header-class="header-nipige-class"
                    id="dateRange"
                    size="sm"
                    ref="date-range"
                    centered
                    hide-footer
                >
                    <b-input
                        class="mb-2"
                        type="date"
                        v-model="startDate"
                    ></b-input>
                    <b-input type="date" v-model="endDate"></b-input>
                    <div class="text-center mt-2">
                        <b-button
                            @click="findButtonClick()"
                            class="my -0 main-navigation-button w-47 mr-2"
                            variant="success"
                            >Find
                        </b-button>
                    </div>
                </b-modal>
            </b-col>
        </b-row>

        <b-row>
            <b-col
                class="text-center"
                md="4"
                v-if="getChartData.labels.length > 0"
            >
                <div class="right-vl">
                    <h4 class="text-center">ORDER STATISTICS</h4>
                    <Doughnut
                        class="piechart"
                        :data="getChartData"
                        :options="chartOptions"
                        :chart-data="getChartData"
                        :chart-options="chartOptions"
                    ></Doughnut>
                </div>
            </b-col>

            <b-col :md="getChartData.labels.length > 0 ? 8 : 12">
                <b-table
                    style="border-radius: 12px"
                    responsive
                    :striped="true"
                    :bordered="true"
                    hover
                    show-empty
                    :fields="title"
                    thead-class="header"
                    :items="getOrderData"
                    @filtered="onFilter"
                    :current-page="currentPage"
                    :per-page="perPage"
                >
                    <template slot="cell(createdAt)" slot-scope="data">{{
                        data.item.createdAt | formatedate
                    }}</template>
                    <template slot="cell(action)" slot-scope="data">
                        <b-button
                            size="sm"
                            class="mr-2"
                            variant="primary"
                            @click="
                                $router.push({
                                    name: 'order-details',
                                    params: {
                                        id: data.item._id,
                                        customerId: currentUser.id,
                                    },
                                })
                            "
                        >
                            <i class="fa fa-eye"></i>
                        </b-button>
                    </template>
                </b-table>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import ebSelect from "@/components/FormElements/Select.vue";
import PieChart from "@/components/chart/piechart.js";
import Doughnut from "@/components/chart/Doughnut.js";
import moment from "moment";
export default {
    components: {
        ebSelect,
        VueSimpleSuggest,
        PieChart,
        Doughnut,
    },
    data() {
        return {
            searchInput: "",
            selected: "",
            options: [
                {
                    text: "Order Number",
                    value: "orderNo",
                },
                {
                    text: "Status",
                    value: "status",
                },
            ],
            selectedStatus: "",
            statusOptions: [
                {
                    text: "Processing",
                    value: "Processing",
                },
                {
                    text: "Confirmed",
                    value: "Confirmed",
                },
                {
                    text: "Delivered",
                    value: "Delivered",
                },
                {
                    text: "Created",
                    value: "Created",
                },
                {
                    text: "Cancelled",
                    value: "Cancelled",
                },
                {
                    text: "Returned",
                    value: "Returned",
                },
                {
                    text: "Dispatched",
                    value: "Dispatched",
                },
                {
                    text: "Refund",
                    value: "Refund",
                },
            ],
            chartOptions: {
                hoverBorderWidth: 10,
            },
            title: [
                {
                    key: "orderId",
                    label: "Order#",
                },
                {
                    key: "createdAt",
                    label: "Order Date",
                },
                {
                    key: "orderStatus",
                    label: "Status",
                },
                {
                    key: "items[0].providerName",
                    label: "Service Provider",
                },
                {
                    key: "orderAmount",
                    label: "Amount",
                },
                {
                    key: "deliveryCharges",
                    label: "Delivery Charge",
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            selectedDate: {
                text: "Today",
                value: 1,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",
            perPage: 10,
            currentPage: 1,
            filterCount: 0,
        };
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm:ss a");
            }
        },
    },
    computed: {
        getOrderData() {
            return this.$store.getters["customerManagement/GetOrderList"];
        },
        getChartData() {
            let dataList =
                this.$store.getters["customerManagement/GetOrderGraph"];
            const labels = [];
            const data = [];
            if (
                dataList &&
                dataList.response &&
                Array.isArray(dataList.response) &&
                dataList.response.length &&
                dataList.response[0].statistic &&
                Array.isArray(dataList.response[0].statistic)
            )
                dataList.response[0].statistic.map((x) => {
                    labels.push(x.orderStatus);
                    data.push(x.total);
                });
            return {
                hoverBackgroundColor: "red",
                hoverBorderWidth: 10,
                labels: labels,
                datasets: [
                    {
                        label: "Data One",
                        backgroundColor: [
                            "#E5DAFB",
                            "#CBB6F8",
                            "#5E3FBE",
                            "#F4F0FD",
                        ],
                        data: data,
                    },
                ],
            };
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        findButtonClick() {
            let e = {
                fromDate: this.startDate,
                toDate: this.endDate,
            };
            this.$refs["date-range"].hide();
            this.fetchChartData();
            this.fetchOrderData();
        },
        changeDate(e) {
            this.selectedDate = e;
            if (e.value == "custom") {
                this.$refs["date-range"].show();
                return;
            }
            this.fetchOrderData();
            this.fetchChartData();
        },
        getDateData(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchChartData() {
            const payload = {
                customerId: this.currentUser.id,
                ...this.getDateData(this.selectedDate.value),
            };
            await this.$store.dispatch(
                "customerManagement/orderGraph",
                payload,
            );
        },
        async fetchOrderData() {
            const payload = {
                id: this.currentUser.id,
                // limit: "20",  For showing all orders
                type: "PRODUCT",
                orderId: "",
                status: "",
                ...this.getDateData(this.selectedDate.value),
            };
            if (this.selected.value == "orderNo") {
                payload.orderId = this.searchInput;
            } else if (this.selected.value == "status") {
                payload.status = this.selectedStatus.value;
            } else {
                payload.orderId = "";
                payload.status = "";
            }
            await this.$store.dispatch(
                "customerManagement/getOrderList",
                payload,
            );
        },
        searchResult() {
            this.fetchOrderData();
        },
        onChangeStatus() {
            this.fetchOrderData();
        },
    },
    async mounted() {
        this.currentUser = this.$route.params;
        await this.fetchChartData();
        await this.fetchOrderData();
    },
};
</script>
<style>
.right-vl {
    border-right: 1px solid grey;
    height: 400px;
}
.piechart {
    display: flex;
    justify-content: center;
}
#doughnut-chart {
    max-width: 500px;
}
.vue-simple-suggest.designed .input-wrapper input {
    border-radius: 2px !important;
    height: calc(2.2125rem + 8px);
    padding: 10px !important;
}
</style>
